$(document).ready(function() {
    if (!window['surveyMonkeyId']) {
        return;
    }

    var cookieName = "surveyMonkey";
    var getCookie = $.cookie(cookieName);
    var name = dataLayer360[0].page_name;

        if ( name != "Checkout-One-Step" && getCookie != "surveyDone") {

            var area = dataLayer360[0].page_id;
            var encodeArea = btoa(area);

            if ( getCookie == null ) {

                var rng = Math.floor(Math.random() * 5) + 1;
                if(rng == 5) {
                    createCookie(cookieName,encodeArea,30);
                } else {
                    createCookie(cookieName,"surveyDone",30);
                }
            } else {
                var cookieDecoded = atob(readCookie(cookieName));
                var reg = new RegExp(area);
                var found = cookieDecoded.match(reg);
                var cookieCombined = area + "," + cookieDecoded;
                var cookieCombinedEncoded = btoa(cookieCombined);

                if (found == null) {
                    eraseCookie(cookieName);
                    createCookie(cookieName,cookieCombinedEncoded,30);
                }

                if(cookieCombined.match(new RegExp(",", "g")).length>=5 && cookieCombined.match(new RegExp("delti_result_search_page", "g")) ) {

                    var surveySize = surveyType();
                    initializeSurveyMonkey(surveySize);

                    eraseCookie(cookieName);
                    createCookie(cookieName,"surveyDone",30);
                }
            }
        }
});

function surveyType() {
    var width = screen.width;
    var data = window.surveyMonkeyId.split(',');
    if ( width < 600 ) {
        surveyCode = data[0];
    } else if ( width > 600 && width < 1300 ) {
        surveyCode = data[1];
    } else {
        surveyCode = data[2];
    }
    return surveyCode;
}

function copyClipboard(surveyUrl) {
       var tmp = document.createElement('textarea');
       tmp.value = surveyUrl;
       tmp.setAttribute('readonly', '');
       tmp.style = {position: 'absolute', left: '-9999px'};
       document.body.appendChild(tmp);
       tmp.select();
       document.execCommand('copy');
       document.body.removeChild(tmp);
}

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

function initializeSurveyMonkey(surveySize) {
    $.ajax({
        url: "/survey-monkey-form",
        type: "GET",
        cache: false,
        data: { code: surveySize },
    }).done(function (response) {
        openSurveyMonkeyFormInPopup(response);
    });
}

function openSurveyMonkeyFormInPopup(response) {
    $.fancybox({
        width: 390,
        height: "auto",
        content: response,
        fitToView: true,
        autoSize: false,
        helpers: {
            overlay: {
                locked: true
            }
        }
    });
}